import { Text } from '@ui/lib/park/ui/text';
import { Position } from '@ui/services/contract/hooks/TradingReaderFacet/useGetPositionV2/types';
import { useTranslation } from 'react-i18next';
import { HStack, Stack, styled } from 'styled-system/jsx';

import { InitialCollateral } from './InitialCollateral';
import { valueStyle } from './styles';
import { PositionMarketData } from './types';

export const CollateralTooltipContent = ({
  position,
  marketData,
}: {
  position: Position;
  marketData?: PositionMarketData;
}) => {
  const { t } = useTranslation();

  return (
    // two compact lines: label row, then value row — fits the tooltip's
    // 360px max width without clipping (label + double amount overflowed
    // as a single line)
    <Stack gap="4px">
      <Text textStyle="v2.label" color="v2.text.muted" whiteSpace="nowrap">
        {t('common.Initial Collateral (After open fee)')}
      </Text>

      <HStack gap="6px" whiteSpace="nowrap">
        <styled.img
          src={position.collateralToken.image}
          width="14px"
          height="14px"
          borderRadius="2px"
        />
        <Text css={valueStyle} color="v2.text.primary">
          {position.collateral.toFixed(2)} {position.collateralToken.symbol}
        </Text>
        <InitialCollateral
          position={position}
          {...(marketData
            ? { marketPrice: marketData.collateralMarketPrice }
            : {})}
          data-cy="CollateralTooltip-InitialCollateral"
        />
      </HStack>
    </Stack>
  );
};
